<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'memuList', query: { roleLevel: roleLevel } }">菜单管理</router-link>
                </li>
                <li class="active">添加/修改</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules" label-width="100px">
                <el-form-item label="菜单名称" prop="name">
                    <el-input v-model="saveModel.name"></el-input>
                </el-form-item>
                <el-form-item label="菜单类型" prop="menuLevel">
                    <el-select v-model="saveModel.menuLevel" :value ="saveModel.menuLevel" placeholder="请选择">
                        <el-option v-for="(item, index) in menuLevels" :key="index" :label="item.name" :value="item.value"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="菜单级别" prop="level">
                    <el-input type="number" v-model="saveModel.level"></el-input>
                </el-form-item>
                <el-form-item label="绑定url" prop="bindurl">
                    <el-input v-model="saveModel.bindurl"></el-input>
                </el-form-item>
                <el-form-item label="传递参数" prop="parameter">
                    <el-input v-model="saveModel.parameter"></el-input>
                </el-form-item>
                <el-form-item label="菜单顺序" prop="sequence">
                    <el-input type="number" v-model="saveModel.sequence"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button size="small" type="primary" @click="saveMemu">保存</el-button>
                    <el-button size="small" @click="resetForm('formName')">重置</el-button>
                    <el-button size="small" @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            menuId: '',
            saveModel: {
                menuLevel:0,
                roleLevel: 1,
            },
            roleLevel: 1,
            userInfo: {},
            parentName:'',
            memberLeveOption:[],
            menuLevels:[
                {
                    name:'主菜单',
                    value:0
                },
                {
                    name:'附属菜单',
                    value:1
                },
            ],
            parentMenu:[],
            rules: {
                name: [
                    { required: true, message: "请输入名称", trigger: "blur" }
                ],
                level: [
                    { required: true, message: "请输入等级", trigger: "blur" }
                ]
            },
        }
    },
    created() {
        var _this = this;
        _this.memberLeveOption = _this.$common.enum_config('EMemberLevel');
        _this.userInfo = _this.$common.user_info();
        _this.menuId = _this.$route.query.menuId;
        if (_this.menuId) {
            _this.detailMenu();
        }
        var parentMenuId = _this.$route.query.parentMenuId || '';
        if(parentMenuId) {
            _this.saveModel.menuLevel = 1;
            _this.saveModel.parentId = parentMenuId;
        }
        _this.roleLevel = _this.$route.query.roleLevel || 1;
        _this.saveModel.roleLevel = _this.roleLevel;
    },
    methods: {
        detailMenu() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/menu/detailMenu',
                data: {
                    menuId: _this.menuId
                },
                success: function(response) {
                    if(response.item){
                      _this.saveModel = response.item;
                    }
                }
            });
        },
        saveMemu() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.$common.my_ajax({
                        url: '/menu/saveMenuInfo',
                        data: _this.saveModel,
                        success: function(response) {
                            // 刷新菜单列表
                            _this.$common.refreshUserMenuAuth(_this.$common.user_info().userId);
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                    _this.$router.go(-1)
                                }
                            });
                        }
                    });
                }
            });
        }
    }
}
</script>